/* ETQ header hover-to-open — desktop only.
   Checks width per-event (no fragile one-time guard), binds on mouseenter
   at the details level, closes on mouseleave with a small delay. */
(function () {
  var CLOSE_DELAY = 150;
  var timers = new WeakMap();

  function isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  function allDetails() {
    return document.querySelectorAll('.header__inline-menu details');
  }

  function closeOthers(except) {
    allDetails().forEach(function (d) {
      if (d !== except && d.hasAttribute('open')) d.removeAttribute('open');
    });
  }

  function bind() {
    allDetails().forEach(function (d) {
      if (d.dataset.etqHoverBound) return;
      d.dataset.etqHoverBound = '1';

      d.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        clearTimeout(timers.get(d));
        closeOthers(d);
        d.setAttribute('open', '');
      });

      d.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        var t = setTimeout(function () {
          d.removeAttribute('open');
        }, CLOSE_DELAY);
        timers.set(d, t);
      });
    });
    console.log('[etq-hover] bound to', allDetails().length, 'menus');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();